import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltModal } from '@cae/cobalt-react/components/modal';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import * as React from 'react';

import type { UnsavedChangesModalProps } from './UnsavedChangesModal.types';

import styles from './UnsavedChangesModal.module.css';

const UnsavedChangesModal = React.memo(
  ({
    isOpen,
    title = 'Are you sure you want to exit?',
    description = 'You have unsaved changes. If you exit now, your changes will be lost.',
    confirmLabel = 'Exit',
    cancelLabel = 'Keep editing',
    onConfirm,
    onCancel,
  }: Readonly<UnsavedChangesModalProps>): React.ReactElement => {
    const isMobile = useMediaQuery(MediaQuery.Mobile);

    return (
      <CobaltModal
        isOpen={isOpen}
        title={title}
        showCloseButton={true}
        onClose={onCancel}
        actionBar={
          <CobaltActionBar
            position="right"
            mobile={isMobile}
            primaryButton={
              <CobaltButton variant="primary" onClick={onConfirm}>
                {confirmLabel}
              </CobaltButton>
            }
            secondaryButton={
              <CobaltButton variant="secondary" onClick={onCancel}>
                {cancelLabel}
              </CobaltButton>
            }
          />
        }
      >
        <p className={styles.description}>{description}</p>
      </CobaltModal>
    );
  }
);

UnsavedChangesModal.displayName = 'UnsavedChangesModal';

export { UnsavedChangesModal };
